import { ApolloQueryResult } from '@apollo/client';
import { EventLogsQuery } from '@stigg-types/apiTypes';

export const transformEventLogResult = (result: ApolloQueryResult<EventLogsQuery>) => ({
  events: result.data?.eventLogs?.edges?.map((edge) => edge.node),
  pageInfo: result.data?.eventLogs?.pageInfo,
});
